<template>
      <v-container fluid>
        <v-row>
          <v-spacer></v-spacer>
          <v-col md="5" sm="6" lg="5" xs="10">
            <b-card class="elevation-0 card-container">
              <b-card-text style="padding: 40px 70px 10px 70px">
                <div class="layout column align-center">
                  <div id="avatarContainer">
                    <img src="../../public/logo2.png" height="40" width="80"/>
                  </div>
                </div>
                <div class="change-pass-header">
                  Изменение пароля
                </div>
                <div class="change-pass-subheader">Укажите текущий и новый пароль</div>
                <b-form>
                  <b-form-group >
                    <label class="label-pass">Текущий пароль</label>
                    <b-input
                            v-model="changePassModel.oldPassword"
                            type="password"
                            name="password"
                            placeholder="Введите ваш текущий пароль"
                    />
                  </b-form-group>
                  <b-form-group >
                    <label class="label-pass">Новый пароль</label>
                    <b-input
                            v-model="changePassModel.newPassword"
                            type="password"
                            placeholder="Введите новый пароль"
                            name="password"
                            :state="errors.findIndex(x=>x.key='newPassword')!=-1||errors.findIndex(x=>x.key='passwordLength')!=-1?changePassModel.newPassword!=null&&changePassModel.newPassword.length>=6?true:false:null"
                    />
                  </b-form-group>
                  <b-form-group>
                    <label class="label-pass">Подтвердите пароль</label>
                    <b-input
                            v-model="confirmPassword"
                            :state="comparePassword"
                            placeholder="Повторите пароль"
                            type="password"
                    />
                    <b-form-invalid-feedback :state="comparePassword">
                      <span style="color: darkred;">Пароли не совпадают!</span>
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="comparePassword">
                      <span style="color: darkgreen;">Пароли совпадают</span>
                    </b-form-valid-feedback>
                  </b-form-group>
                </b-form>
              </b-card-text>
              <v-card-actions style="padding: 0 70px">
                <v-btn
                        style="text-transform: capitalize"
                        dark
                        color="var(--color-blue)"
                        @click="changePass"
                >
                  Отправить
                </v-btn>
              </v-card-actions>
            </b-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  import axios from 'axios';
  const apiLink=process.env.VUE_APP_API_LINK
    export default {
        name: "PersonalArea",
      data() {
        return {
          errors:[],
          confirmPassword:'',
          changePassModel:{
            login:null,
            oldPassword:null,
            newPassword:null
          },
          rules: {
            required: value => !!value || 'Поле обязательно к заполнению!'
          }
        }
      },
      methods:{

          validatePass(){
            var noError = true;
            this.errors = [];

            if (this.changePassModel.newPassword.length<6) {
              this.errors.push({key: "passwordLength", mes: "Пароль не должен быть менее 6 символов!"});
              noError = false;
            }
            if (this.changePassModel.oldPassword == this.changePassModel.newPassword) {
              this.errors.push({key: "newPassword", mes: "Новый пароль совпадает со старым!"});
              noError = false;
            }

            return noError;

          },

        async changePass(){
          if(this.webUserInfo!=null){
            //проверяем заполненность
            if(this.validatePass()) {
              this.changePassModel.login = this.webUserInfo.account;
              var curUser = this.$store.state.userData.curUser;
              let isCorrect = false;
              const vm = this;
              await axios.post(`${vm.$root.identityURL}/api/UserAccount/ChangePassword`, this.changePassModel, {headers: {Authorization: "Bearer " + curUser.access_token}}).then(() => {
                this.$bvToast.toast("Пароль успешно обновлен", {
                  variant: "success",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 3000,
                  solid: true
                })
                for (var key in this.changePassModel) {
                  this.changePassModel[key] = null;
                }
                this.confirmPassword = '';
              }).catch(error => {
                this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                  title: `Ошибка обновления пароля!`,
                  variant: "danger",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 3000,
                  solid: true
                })
              });
            }
            else{
              this.errors.forEach(err => {
                this.$bvToast.toast(err.mes, {
                  title: `Ошибка валидации!`,
                  variant: "warning",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 7000,
                  solid: true
                })
              })
            }

          }

        },

      },
      computed:{
        ...mapGetters({
          webUserInfo:"userData/getWebUser"
        }),

        comparePassword(){
          return this.confirmPassword?this.changePassModel.newPassword==this.confirmPassword:null;
        },


        userName() {
          if (this.webUserInfo != null) {
            return this.webUserInfo.userName.split(/\s/);
          }
          else return '';
        }
      }
    }
</script>

<style scoped>

  .label-pass{
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
  }

  #avatarContainer{
    position: relative;
  }
  #changeAvatar{
    position: absolute;
    top: 90px;
    left:25px;
    color:white;
    cursor:pointer;
  }

  .change-pass-header{
    margin-top:70px;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    color:black;
  }

  .change-pass-subheader{
    font-weight: 500;
    font-size: 14px;
    line-height: 30px;
    color:black;
    margin-bottom: 30px;
  }

  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }

</style>
